import React from 'react';
import { BrainCircuit } from 'lucide-react';

interface LogoIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const LogoIcon: React.FC<LogoIconProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <BrainCircuit 
      className={className}
      width={size}
      height={size}
      color={color}
    />
  );
};

export default LogoIcon;
